// Module
var code = `<video-js class="lesson-video vjs-big-play-centered" id="vid1" controls preload></video-js> `;
// Exports
export default code;